import React from 'react'

import { useTranslation } from 'react-i18next'
import { User, USER_ROLES } from 'Types/User'
import { ExtraOptionPopOver } from '../ExtraOptionPopOver/ExtraOptionPopOver'
import { RowPart, UserManagementRowStyled } from './UserManagementRow.styled'

type UserManagementRowProps = {
  user: User
  shouldShowExtraOptionsModal: boolean
  setExtraModalOn: (userEmail: string) => void
}

export const UserManagementRow = ({
  user,
  shouldShowExtraOptionsModal,
  setExtraModalOn,
}: UserManagementRowProps) => {
  const { t } = useTranslation('accountSettings')
  const notAcceptInvitation = !!user.invitationId

  const userName = user.name || user.email.split('@')[0] || ''

  const userPermissions =
    user.role === USER_ROLES.OWNER ? t('user_management.owner') : t('user_management.read_only')
  const renderDomainName = () => {
    if (user.role === USER_ROLES.OWNER) return t('user_management.all_domains')
    const userDomains = user.domains ?? []
    const plusMore = userDomains.length > 1 ? `+ ${userDomains.length - 1} more` : ''
    return `${userDomains[0]} ${plusMore}`
  }

  return (
    <UserManagementRowStyled notActive={notAcceptInvitation}>
      <RowPart css={{ width: '20%' }}>{userName}</RowPart>
      <RowPart css={{ width: '25%' }}>{user.email}</RowPart>
      <RowPart css={{ width: '20%' }}>{userPermissions}</RowPart>
      <RowPart css={{ width: '35%' }}>{renderDomainName()}</RowPart>
      <ExtraOptionPopOver
        onOpenChange={(open) => {
          if (!open) {
            setExtraModalOn('')
          } else {
            setExtraModalOn(user.email)
          }
        }}
        isOpen={shouldShowExtraOptionsModal}
        user={user}
        notAcceptInvitation={notAcceptInvitation}
      />
    </UserManagementRowStyled>
  )
}
